
import { Watch, ObjectTypesHelper,  BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, BaseTLTableBase, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
	import { TaskService, TaskFilter } from "../../../Services/ContBase/AllConServices";

	export default abstract class TaskListBase extends BaseTLTableComponent {
		taskService: TaskService = new TaskService();


		objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Content;
		modalContent: string = this.$t('task.messageQuestionMain').toString();

		selectRowsBase(items: any) {
			super.selectRows(items);
		}

		moreActionAllowDelegate(): boolean {
			for (var i = 0; i < this.selectItems.length; i++) {
				if (this.tableData.filter(c => c.id == this.selectItems[i] && c.canDelegate).length > 0) {
					return true && this.canUpdate;
				}
			}
			return false;
		}

		moreActionAllowStop(): boolean {
			for (var i = 0; i < this.selectItems.length; i++) {
				if (this.tableData.filter(c => c.id == this.selectItems[i] && c.canStop).length > 0) {
					return true && this.canUpdate;
				}
			}
			return false;
		}

	
		//tady identifikuji to co natahnu
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: TaskFilter = new TaskFilter(this.$store.state.idTenant, false);
			return this.taskService.getAllByRefreshFilter(filter);
		}

		refreshItems(items: any[], refreshData: any[]): any[] {
			for (var i = 0; i < items.length; i++) {
				items[i].idTaskStateNavigationName = refreshData[i].idTaskStateNavigationName;
				items[i].screenList = refreshData[i].screenList;
			}
			return items;
		}


		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: TaskFilter = new TaskFilter(this.$store.state.idTenant, false);
			return this.taskService.getAllByFilter(filter);
		}

		prepareItems(items: any[]) {
			// zde zatim nepotrebujeme
			for (var i = 0; i < items.length; i++) {
				var validFrom = tlISODateToLocalString(items[i].validFrom);
				var validTo = tlISODateToLocalString(items[i].validTo);
				if (items[i].validFrom == undefined && items[i].validTo == undefined) {
					items[i].validRange = this.$t('task.validityUnlimited').toString();
				}
				else if (items[i].validTo == undefined) {
					items[i].validRange = this.$t('task.validityFrom').toString() + validFrom;
				}
				else if (items[i].validFrom == undefined) {
					items[i].validRange = this.$t('task.validityTo').toString() + validTo;
				}
				else {
					items[i].validRange = validFrom + ' – ' + validTo;
				}
			}
		}

		changeTagsBase(items: any, idLast: number) {
			var tagsItem = (this.tableData as Array<any>).filter(c => c.id == idLast)[0];
			tagsItem.tags = items;
		}

		goBackDetailModalBase(item: any, tableData: Array<any>): void {
			for (var i = 0; i < tableData.length; i++) {
				var changeItem = (tableData[i].tags as Array<any>).filter((c: any) => c.id == item.id);
				if (changeItem.length > 0) {
					changeItem[0].name = item.name;
					changeItem[0].color = item.color;
				}
			}
		}

		//itemsSelected: any;
		//isDelete: boolean = false;
		//isStop: boolean = false;
		//isDelegate: boolean = false;

		callAction(isDelete: boolean, isStop: boolean, isDelegate: boolean) {
			if (this.itemsSelected) {
				let idList: number[] = this.getSelectedList();
				if (isDelete) {
					this.deleteSelected(idList);					
				}
				else if (isDelegate) {
					this.delegateSelected(idList);
					
				}
				else if (isStop) {
					this.stopSelected(idList);
				}
			}
			this.itemsSelected = null;
			(this.$refs.tasksTable as BaseTLTableBase).clearSelected();
		}

		showAllertToDeleteClickBase(itemsSelected: any) {
			this.showAllertBeforeActionClickBase(itemsSelected, this.$t('task.messageQuestionMain').toString(), true, false, false);
		}

		deleteSelected(idList: number[]) {
			if (idList.length > 0) {
				this.isBusy = true;
				this.deleteItemsList = idList;
				super.deleteList();
			}
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.taskService.deleteList(this.deleteItemsList);
		}

		protected showAllertBeforeActionClickBase(itemsSelected: any, modalContent: string, isDelete: boolean, isStop: boolean, isDelegate: boolean) {
			this.isDelete = isDelete;
			//this.isStop = isStop;
			//this.isDelegate = isDelegate;
			this.modalContent = modalContent;
			this.itemsSelected = itemsSelected;
			this.showAlertModalById('alertModalIdAllow');
		}

		countToRemove = 0;
		protected prepareRemoveMessageStopDelegate(isStop: boolean) {
			var one = isStop ? this.$t('task.messageQuestionMainStop').toString() : this.$t('task.messageQuestionMainDelegate').toString()
			var messageRemoveTwoFour = isStop ? this.$t('task.messageQuestionMainStop2').toString() : this.$t('task.messageQuestionMainDelegate2').toString()
			var messageRemoveFiveAndMore = isStop ? this.$t('task.messageQuestionMainStop3').toString() : this.$t('task.messageQuestionMainDelegate3').toString()
			var allMessage = one;
			//var countToRemove = this.selectItems.length;
			
			if (this.countToRemove > 1) {
				var message = '';
				message = this.countToRemove > 1 && this.countToRemove < 5 ? messageRemoveTwoFour : message;
				message = this.countToRemove >= 5 ? messageRemoveFiveAndMore : message;
				var count = " <span style=color:red; font-weight: 900;> &nbsp;" + this.countToRemove + " &nbsp;  </span>  ";
				allMessage = this.countToRemove < 5 ? messageRemoveTwoFour : messageRemoveFiveAndMore;
				allMessage = allMessage.replace('{0}', count);
			}
			return allMessage;
		}

		showAllertToDelegateClick(itemsSelected: any) {
			this.showAllertBeforeActionClickBase(itemsSelected, this.$t('task.messageDelegate').toString(), false, false, true);
		}

		//TODO dát do předka
		delegateSelected(idList: number[]) {
			if (idList.length > 0) {
				this.isBusy = true;
				this.delegateList(idList).then(() => this.fetchData())
					.catch((error) => {
						var errorMessage = this.$t('task.errorTaskNotDeletage').toString();
						super.showAlertModalWithErrorMessageList(errorMessage);
						this.isBusy = false;
					});
			}
		}

		delegateList(idList: number[]): Promise<AxiosResponse<any>> {
			return this.taskService.delegateList(idList);
		}

		showAllertToStopClick(itemsSelected: any) {
			this.showAllertBeforeActionClickBase(itemsSelected, this.$t('task.messageStop').toString(), false, true, false);
		}

		//TODO dát do předka
		stopSelected(idList: number[]) {
			if (idList.length > 0) {
				this.isBusy = true;
				this.stopList(idList).then(() => this.fetchData())
					.catch((error) => {
						var errorMessage = this.$t('task.errorTaskNotStop').toString();
						super.showAlertModalWithErrorMessageList(errorMessage);
						this.isBusy = false;
					});
			}
		}

		stopList(idList: number[]): Promise<AxiosResponse<any>> {
			return this.taskService.stopList(idList);
		}


        setFields() {
            this.fields = [
				//{ key: 'idTaskTypeNavigationName', label: this.$t('task.fieldType'), trans: 'task.fieldType', sortable: true, class: 'text-left', visible: true, optional: false },
				{ key: 'name', label: this.$t('task.fieldName'), trans: 'task.fieldName', sortable: true, class: 'text-left', design: 'detail' },
				{ key: 'idTaskTypeNavigationName', label: this.$t('task.fieldType'), trans: 'task.fieldType', sortable: true, class: 'text-left', visible: true, optional: false, design: 'taskTypeImage' },
				



                //	{ key: 'id', label: 'Náhled', sortable: false, class: 'text-center columnImage', design: 'popupImage' },
              
				{ key: 'idTaskStateNavigationName', label: this.$t('task.fieldStatus'), trans: 'task.fieldStatus', sortable: true, class: 'text-left', visible: true, optional: false, design: 'taskStatus' },
                //{ key: 'activeOnReceiversCountText', label: 'Přiřazeno k', sortable: true, class: 'text-center', visible: true, optional: true },
				//{ key: 'receiverAssignedDesign', label: this.$t('task.fieldDelegate'), trans: 'task.fieldDelegate', sortable: false, class: 'text-center', tooltip: 'allScreensNameHtml', design: 'tooltipColumnBackGround', minLengthToShowTooltip: 4 },
				{ key: 'screenList', label: this.$t('task.fieldDelegate'), trans: 'task.fieldDelegate', sortable: false, class: 'text-left', tooltip: 'screenList', design: 'allReceivers' },

				{ key: 'tags', label: this.$t('task.fieldTags'), trans: 'task.fieldTags', sortable: false, class: 'text-left', design: 'tags', action: 'filter', tooltip: 'tags' },
				//{ key: 'screenList', label: this.$t('task.fieldDelegate'), trans: 'task.fieldDelegate', sortable: false, class: 'text-center', tooltip: 'allScreensNameHtml', design: 'link_tooltip_list', minLengthToShowTooltip: 4 },
               { key: 'validRange', label: this.$t('task.fieldValidity'), trans: 'task.fieldValidity', sortable: false, class: 'text-left', visible: false, optional: true },
                { key: 'description', label: this.$t('task.fieldDescription'), trans: 'task.fieldDescription', sortable: true, class: 'text-left', visible: false, optional: true },
                { key: 'creationDate', label: this.$t('task.fieldCreated'), trans: 'task.fieldCreated', sortable: true, class: 'text-left', visible: false, optional: true, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
                { key: 'whenChanged', label: this.$t('task.fieldChanged'), trans: 'task.fieldChanged', sortable: true, class: 'text-left', visible: false, optional: true, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
				//tohle tam musi být i neviditelné
				{ key: 'idTaskStateNavigationIdentifier', label: 'Neviditelny', sortable: false, class: 'text-left', optional: true, visible: false, show: false },
				{ key: 'actions', label: this.$t('task.fieldActions'), trans: 'task.fieldActions', class: 'text-right ', thClass: 'lastColumnTable' }
            ]
        };

		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'name', label: this.$t('task.fieldName'), trans: 'task.fieldName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					//{ key: 'idTaskStateNavigationName', label: this.$t('task.fieldStatus'), trans: 'task.fieldStatus', selected: false, value: null, type: 'text', enum: 'ENU_CON_Task_TaskState', useEnum: true, refItem: 'idTaskStatusName' },		
					//{ key: 'idTaskTypeNavigationName', label: this.$t('task.fieldType'), trans: 'task.fieldType', selected: false, value: null, type: 'text', enum: 'ENU_CON_Task_TaskType', useEnum: true, refItem: 'idTaskTypeName' },
					{ key: 'tags', label: this.$t('task.filterTag'), trans: 'task.filterTag', selected: false, value: null, type: 'multi', multiselect: true },

				];

				//skupinovy filtr
				
				var taskStateEnums = { key: 'ENU_CON_Task_TaskState', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idTaskStateNavigationIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('task.fieldStatus'), trans: 'task.fieldStatus', isNegative: true };
			
				//super.loadFiltersEnum(taskStateEnums);	

				var taskTypeEnums = { key: 'ENU_CON_Task_TaskType', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idTaskTypeNavigationIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('task.fieldType'), trans: 'task.fieldType', isNegative: true };

				super.loadFiltersEnumList([taskStateEnums, taskTypeEnums]);
			}
		}

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
			this.setfilters(null);
			this.fetchData();
		}

	};